import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ScrapeTaskDataViewer from '../../components/admin/scrape/ScrapeTaskDataViewer';

const ScrapeTaskDataView: React.FC = () => {
  return (
    <AdminLayout>
      <ScrapeTaskDataViewer />
    </AdminLayout>
  );
};

export default ScrapeTaskDataView;